import { useTranslation } from 'react-i18next'
import mainLogo from '../svg/logoIcon.svg'

export const LogoIconWithText = () => {
  const { t } = useTranslation()

  return <img src={mainLogo} width="120px" height="auto" alt={t('a11y.alt.main-logo')} />
}
